import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/recipients")({
  component: lazyRouteComponent(() => import("./-pages/account.recipients")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.recipients.meta.title"] },
      { name: "description", content: DICTS.en["account.recipients.meta.description"] },
      { property: "og:title", content: DICTS.en["account.recipients.meta.title"] },
      { property: "og:description", content: DICTS.en["account.recipients.meta.description"] },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
